import {
  useJsonForms,
  withJsonFormsControlProps,
  JsonFormsDispatch,
} from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  UISchemaElement,
  Labeled,
  Internationalizable,
  isDescriptionHidden,
  isDateControl,
} from "@jsonforms/core";
import { useState, useEffect } from "react";
import CustomBaseRenderers from "./CustomBaseRenderer";
import showRule from "../../RuleEvaluate";

interface CustomGroupProps
  extends UISchemaElement,
    Labeled,
    Internationalizable {
  type: "CustomGroup";
  title?: string;
  titleClassName?: string;
  groupClassName?: string;
  elements: UISchemaElement[];
  additionalData?: any;
}

export const CustomGroup = ({
  data,
  handleChange,
  path,
  schema,
  visible,
  uischema,
}: ControlProps) => {
  const [selectedOption, setSelectedOption] = useState("");
  const uischemaFile = uischema as unknown as CustomGroupProps;
  const ctx = useJsonForms();
  const materialCells = ctx?.cells;
  const customRenderers = CustomBaseRenderers;

  const { groupClassName, title, titleClassName, additionalData } =
    uischemaFile;
  let show =
    uischema?.options?.show === undefined ? true : uischema?.options?.show;

  if (additionalData?.customRule) {
    show = showRule(additionalData, ctx);
  }
  visible = show && visible;
  const func = (ele: any) => {
    let testData = ele;
    if (!testData.options) {
      testData.options = {};
    } else {
      let optionsData = {
        ...testData?.options,
        show: show,
      };

      testData.options = optionsData;
    }

    return testData;
  };

  return (
    <div className={`${show ? "" : "h-0 mt-0 mb-0"}`}>
      <p
        className={`${show ? titleClassName : "hidden"} ${
          show
            ? "font-openSans font-semibold text-mobile-body-lg lg:text-web-subheading leading-[22px] lg:leading-4 text-brand-bgBlack uppercase"
            : "hidden"
        } `}
      >
        {title}
      </p>
      <div className={`${show ? groupClassName : "h-0"}`}>
        {uischemaFile?.elements.map((ele, index) => (
          <JsonFormsDispatch
            key={`element-${index}`}
            uischema={func(ele)}
            renderers={customRenderers}
            cells={materialCells}
          />
        ))}
      </div>
    </div>
  );
};

export default withJsonFormsControlProps(CustomGroup);
